var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('van-image',{staticClass:"title",attrs:{"src":require('@/assets/chengnuoshu.png')}}),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.datas.commitment)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }